<template>
  <FormClient :id="id" />
</template>

<script>
import FormClient from '@/components/Form/Client'
export default {
  props: {
    id: [String, Number],
  },
  components: {
    FormClient,
  },
}
</script>

<style></style>
